module.exports = __webpack_public_path__ + "static/img/edge_img_5.52ad6cd4.png";